import { render, staticRenderFns } from "./ReportsLog.vue?vue&type=template&id=36b19dc1&scoped=true"
import script from "./ReportsLog.vue?vue&type=script&lang=ts"
export * from "./ReportsLog.vue?vue&type=script&lang=ts"
import style0 from "./ReportsLog.vue?vue&type=style&index=0&id=36b19dc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b19dc1",
  null
  
)

export default component.exports